import { render, staticRenderFns } from "./EcocolordopplerArtiSuperioriEdit.vue?vue&type=template&id=4819cb65&scoped=true"
import script from "./EcocolordopplerArtiSuperioriEdit.vue?vue&type=script&lang=js"
export * from "./EcocolordopplerArtiSuperioriEdit.vue?vue&type=script&lang=js"
import style0 from "./EcocolordopplerArtiSuperioriEdit.vue?vue&type=style&index=0&id=4819cb65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4819cb65",
  null
  
)

export default component.exports